<template>
  <a id="container-download-app"
     class="container-banner container-download-app no-gutters tAc"
     href="https://wegow.app.link/PlwT8EHdi0"
     rel="noreferrer"
     target="_blank"
     :class="{ home: home }">
    <div class="posR container-mobile-img" />
    <div class="container-right">
      <div class="container-text">
        <p class="title"
           v-html="$t('purchase.descargateLaAppDeWegow')" />
      </div>
      <div class="apps">
        <div class="apps-icon appStore" />
        <div class="apps-icon googlePlay" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    home: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import './banner-download-app.sass'
</style>
